/**
 * @module components/Form/FormGroupSiteDesignationXV
 * @author Charles Blais <charles.blais@canada.ca>
 *
 * Form group for getting year
 */
import { Col, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

import { useLanguageState } from '../../contexts/language-state-provider';

import { useAppState } from '../../contexts/app-state-provider';


type Props = {
  value?: number,
  onChange: React.FormEventHandler<FormControl>
}

/**
 * React component
 * ===============
 */
const FormGroupSiteDesignationXV = ({
  value,
  onChange,
}: Props) => {
  const [ lang ] = useLanguageState();
  const [ state ] = useAppState();

  return (
    <FormGroup
      controlId="siteDesignationXV"
    >
      <Col componentClass={ControlLabel} sm={2}>
        {lang.form.siteDesignationXV}
      </Col>
      <Col sm={10}>
        <FormControl
          type="number"
          step="1"
          min={state.form.siteDesignationsXVLimit[0]}
          max={state.form.siteDesignationsXVLimit[1]}
          value={value}
          onChange={onChange}
        />
      </Col>
    </FormGroup>
  );
}

export default FormGroupSiteDesignationXV;
